import {reportError} from '~/error/report'
import Country from '~/locale/country'

const SMALL_NUMBER_OF_USERS = 10

export const getCalendlyUrlForPlanUpdate = (country: string, numberOfUsers: number): string => {
    const baseUrl = 'https://calendly.com'

    switch (country) {
        case Country.DK:
            return `${baseUrl}/getpleo/intro-til-pleo-virtuelt-mode`
        case Country.SE:
            return `${baseUrl}/pleo-intro-se/pleo-intro`
        case Country.DE: {
            return `${baseUrl}/pleo-intro-de/pleo-de-2`
        }
        case Country.GB:
            if (numberOfUsers < SMALL_NUMBER_OF_USERS) {
                return `${baseUrl}/pleo-uk/pleo-presentation`
            }
            return `${baseUrl}/pleo-uk-sales/intro-to-pleo`
        case Country.ES:
            return `${baseUrl}/pleo-es/pleo-demo`
        case Country.IE:
            return `${baseUrl}/pleo-ireland/pleo-demo-ireland`
        default: {
            reportError('CalendlyCountryNotFound', null, {
                country,
            })
            return `${baseUrl}/getpleo/intro-til-pleo-virtuelt-mode`
        }
    }
}
